import { Component, ViewChild } from '@angular/core';
import { ApcopayComponent } from 'src/app/public/payments/apcopay/apcopay.component';
import { JccComponent } from 'src/app/public/payments/jcc/jcc.component';
import { TrustpaymentComponent } from 'src/app/public/payments/trustpayment/trustpayment.component';

@Component({
  selector: 'app-checkout-payment-forms',
  templateUrl: './checkout-payment-forms.component.html',
  styleUrl: './checkout-payment-forms.component.scss'
})
export class CheckoutPaymentFormsComponent {
    @ViewChild('trustpaymentComponent') trustpaymentComponent: TrustpaymentComponent;
    @ViewChild('apcopayComponent') apcopayComponent: ApcopayComponent;
    @ViewChild('jccComponent') jccComponent: JccComponent;

}
